<template>
  <transition name="offline-fade">
    <div v-if="!isOnline" class="offline-indicator">
      <span class="offline-indicator__dot"></span>
      {{ $t('global.offline') }}
    </div>
  </transition>
</template>

<script setup lang="ts">
import { useOnline } from '@/utils/online'

const { isOnline } = useOnline()
</script>

<style scoped lang="scss">
.offline-indicator {
    position: fixed;
    top: max(16px, env(safe-area-inset-top));
    left: 50%;
    transform: translateX(-50%);
    z-index: 10001;
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 20px;
    font-size: 16px;
    font-weight: 700;
    line-height: 1;
    color: var(--color-white);
    background: var(--color-red, #DB4723);
    border-radius: 999px;
    box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.25);
    pointer-events: none;
    user-select: none;

    &__dot {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background: var(--color-white);
        animation: offline-pulse 1.2s ease-in-out infinite;
    }
}

@keyframes offline-pulse {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.3; }
}

.offline-fade-enter-active,
.offline-fade-leave-active {
    transition: opacity 0.25s ease, transform 0.25s ease;
}

.offline-fade-enter-from,
.offline-fade-leave-to {
    opacity: 0;
    transform: translateX(-50%) translateY(-8px);
}
</style>
